module.exports = __webpack_public_path__ + "img/the-80s.41407a49.png";